<template>
<div class="SFaddi">
    <template v-if="props.properties">

        <div class="SFaddi__head">
            <div class="SFaddi__head-title">Фильтры</div>
            <button class="SFaddi__head-reset" @click="reset">Сбросить все</button>
        </div>

        <MyCheckbox :choosed="props.choosed.withPlaces" @input="select('withPlaces', $event)" class="SFaddi__igroup">
            <span class="SFaddi__title">Только с местами</span>
        </MyCheckbox>

        <MyPrice :list="properties.minprice" :choosedFrom="props.choosed.minPriceFrom" :choosedTo="props.choosed.minPriceTo" 
            class="SFaddi__igroup"
            @input="select_price($event)">
            <div class="SFaddi__title_price">Цена за одного человека</div>
        </MyPrice>

        <MyMultiVert :list="properties.popularRoutes" :choosed="props.choosed.popularRoutes" @input="select('popularRoutes', $event)" placeholder="..." class="SFaddi__igroup">
            <div class="SFaddi__title">Популярные маршруты</div>
        </MyMultiVert>

        <MyMultiVert :list="properties.routeCities" :choosed="props.choosed.routeCities" @input="select('routeCities', $event)" placeholder="..." class="SFaddi__igroup">
            <div class="select__title">Города по маршруту</div>
        </MyMultiVert>

        <MyMultiVert :list="properties.rivers" :choosed="props.choosed.river" @input="select('river', $event)" placeholder="..." class="SFaddi__igroup">
          <div class="select__title">{{isSea() ? 'Моря' :  'Реки / Озера / Моря'}}</div>
        </MyMultiVert>

        <MyCheckbox :choosed="props.choosed.is_oneway" @input="select('is_oneway', $event)" class="SFaddi__igroup">
            <span class="SFaddi__title">В одну сторону</span>
        </MyCheckbox>

        <MyMultiVert :list="properties.dps" :onlyone="true" :limit="2" :choosed="props.choosed.dps" @input="select('dps', $event)" placeholder="..." class="SFaddi__igroup">
            <div class="select__title">Оператор</div>
        </MyMultiVert>

        <MyCheckbox :choosed="props.choosed.is_klk" @input="select('is_klk', $event)" class="SFaddi__igroup">
            <span class="SFaddi__title">Оплата баллами</span>
        </MyCheckbox>

    </template>
    <template v-else><Loader class="loader" /></template>

</div>
</template>

<style lang="scss" src="./SFmain.scss"></style>

<script setup>
import {ref, unref, computed} from 'vue'
import MyMultiVert from '@/comp/MyMutliVert/MyMultiVert.vue'
import MyPrice from '@/comp/MyPrice/MyPrice.vue'
import MyCheckbox from '@/comp/MyCheckbox/MyCheckbox.vue'
import Loader from '@/comp/Loader/Loader.vue'

const props = defineProps({
    properties: Object,
    choosed: Object,
    last: Object,
    ctype: String,
    showFind: Boolean,
})
const emits = defineEmits([ 'input', 'reset' ])

const isSea = () => 'sea' === props.ctype

const select = (key, val) => {
    emits('input', {[key]:val} )
}
const select_price = ({ to, from }) => {
//console.log('select_price', from, to, )    
    emits('input', { minPriceFrom : from, minPriceTo : to  } )
}


const reset = () => {
    emits('reset')
}

</script>